<template>
    <div class="user-join text-center note">
      <template v-if="message_doc.user_id == loggedInUserId && message_doc.parsed_items.length > 0">
          <span class="link" @mouseover="showUsers = true" >{{$t("Users")}}</span>
          <ul v-show="showUsers" class="missed-call-users" @mouseover="showUsers = true"
            @mouseout="showUsers = false">

              <li v-for="user_id in message_doc.parsed_items" class="link" @click="ShowUser(user_id)"
              @mouseover="showUsers = true" @mouseout="showUsers = false">{{GetUser(user_id).username}}</li>
          </ul>
          <span class="theme-red">
              {{$t("have missed the call")}}
              <b>{{new Date(message_doc.created_at * 1000).toLocaleDateString($i18n.locale, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })}}</b>
          </span>
        </template>
        <template v-else>
          {{$t("You have missed the call from")}}
          <b class="link" @click="ShowUser(message_doc.user_id)">{{GetUser(message_doc.user_id).username}}</b>
          {{$t("at")}}
          <span class="theme-red">
              <b>{{new Date(message_doc.created_at * 1000).toLocaleDateString($i18n.locale, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })}} </b>
          </span>
          <!-- <br/> -->
          <span class="btn btn-primary pointer btn-redesign theme-green pointer" @click="JoinCall()">
            <i class="fal fa-phone-plus"></i> {{$t('Join')}}
          </span>
        </template>
    </div>
</template>




<script>
import Vue from 'vue'
import Global from '../scripts/Global'
import { CPUtils } from '../scripts/Utils'
import ChannelApi from '../scripts/api/channel.api'
import { serverBus } from '../main'
import SessionManager from '../Manager/Session.manager'
import VueSignals from '@/scripts/VueSignals'
import CPLink from './CPLink'



export default {
  name: 'MissedCallMessage',
  data: function() {
    return {
      postHoverID: '',
      showUsers: false,
      loggedInUserId: SessionManager.getLoggedInUserId(),
    }
  },
  props: {
    message_doc: Object,
  },
  mounted() {

  },
  methods : {
      GetUser(user_id){
          let user = SessionManager.getUser(user_id)
          if(typeof user != 'undefined')
            return user

      return ''
    },
    ShowUser(user_id){
        Global.globalValue(VueSignals.RIGHT_SIDEBAR_COLLAPSED, false)
        Global.globalValue(VueSignals.SHOW_MENTION_DETAILS, {
            "data_id": user_id,
            "type": 'user'
        })
    },
    JoinCall(){
      ChannelApi.join_call(SessionManager.getActiveChannelId()).then(res=>{
          if(res.data.result){
              // @TODO check
          }else {

          }
      })
    }
  }
}
</script>
